import HBSwiper from "@/components/HBSwiper";
import BoardCardNew from "../BoardCardNew";
import styles from "./index.module.less";

interface SameBoardOperationCardProps {
  record: {
    pinId: string;
    boards: any[];
  };
  columnSize: number;
  customColumnNum?: number;
  stackIndex?: number; // 新增：弹窗堆栈索引，用于生成唯一key
}

export default function SameBoardOperationCard({
  record,
  columnSize,
  customColumnNum,
  stackIndex = 0,
}: SameBoardOperationCardProps) {
  const colNum = Math.max(3, customColumnNum || 3);

  return (
    <div
      key={`boardOperation-${stackIndex}-${record.pinId}`}
      className={`board-operation-wrapper ${styles.sameBoardOperation}`}
      style={{
        width: columnSize * colNum + 16 * (colNum - 1), // 保持动态宽度计算
      }}
    >
      <div className={styles.title}>同在画板</div>
      <div className={styles.content}>
        <HBSwiper
          className={styles.swiper}
          contentClassName={styles.swiperContent}
          iconClassName={styles.icon}
          hideGradient={true}
        >
          {record.boards.map((board, idx) => (
            <div
              key={`${stackIndex}-${board.board_id || idx}`}
              className={styles.boardCard}
            >
              <BoardCardNew
                record={board}
                hideButton={true}
                hideUser={true}
                location={idx + 1}
                viewSource={record.pinId} // 传递当前pin的ID作为viewSource参数
                stackIndex={stackIndex}
              />
            </div>
          ))}
        </HBSwiper>
      </div>
    </div>
  );
}
